import { API_JWT_TOKEN_NAME, CALL_API } from '../middleware/api'

export const BUSINESS_ID_REQUEST = 'BUSINESS_ID_REQUEST'
export const BUSINESS_ID_SUCCESS = 'BUSINESS_ID_SUCCESS'
export const BUSINESS_ID_FAILURE = 'BUSINESS_ID_FAILURE'
export const BUSINESS_ID_RESET = 'BUSINESS_ID_RESET'

export function fetchBusinessById(id) {
  return {
    [CALL_API]: {
      endpoint: '/api/business/businesses/' + id + '/',
      types: [BUSINESS_ID_REQUEST, BUSINESS_ID_SUCCESS, BUSINESS_ID_FAILURE],
      method: 'GET',
      tokenType: API_JWT_TOKEN_NAME,
    },
  }
}

export function resetFetchBusinessById() {
  return {
    type: BUSINESS_ID_RESET,
  }
}
